import { WorkOrderPanelTab, WorkOrderPanelTarget } from './work-order-panel.models';

export const PANEL_SECTIONS: ReadonlyArray<{ id: WorkOrderPanelTab; label: string; icon: string }> = [
  { id: 'overview', label: 'Overview', icon: 'fa-sliders' },
  { id: 'route', label: 'Route', icon: 'fa-location-dot' },
  { id: 'schedule', label: 'Schedule', icon: 'fa-calendar-days' },
  { id: 'contacts', label: 'Contacts', icon: 'fa-address-book' },
  { id: 'freight', label: 'Freight', icon: 'fa-truck' },
  { id: 'notes', label: 'Notes', icon: 'fa-comment' },
  { id: 'status', label: 'Status', icon: 'fa-route' },
];

// Match stable column IDs, including optional columns added through Columns.
// Column positions and display labels can change without changing these targets.
const COLUMN_TARGETS: Readonly<Record<string, WorkOrderPanelTarget>> = {
  route_label: { tab: 'route' },
  shipper_name: { tab: 'route', field: 'shipper' },
  shipper_locality: { tab: 'route', field: 'shipper' },
  shipper_region: { tab: 'route', field: 'shipper' },
  consignee_name: { tab: 'route', field: 'consignee' },
  consignee_locality: { tab: 'route', field: 'consignee' },
  consignee_region: { tab: 'route', field: 'consignee' },
  party_label: { tab: 'contacts' },
  customer_name: { tab: 'contacts', field: 'customer' },
  carrier_name: { tab: 'contacts', field: 'carrier' },
  customer_locality: { tab: 'contacts', field: 'customer' },
  customer_region: { tab: 'contacts', field: 'customer' },
  carrier_locality: { tab: 'contacts', field: 'carrier' },
  carrier_region: { tab: 'contacts', field: 'carrier' },
  schedule_label: { tab: 'schedule' },
  appointment_window_label: { tab: 'schedule', field: 'appointment_date' },
  appointment_date: { tab: 'schedule', field: 'appointment_date' },
  appointment_start: { tab: 'schedule', field: 'appointment_start' },
  appointment_end: { tab: 'schedule', field: 'appointment_end' },
  appointment_timezone: { tab: 'schedule', field: 'appointment_timezone' },
  load_start: { tab: 'schedule', field: 'planned_times' },
  load_end: { tab: 'schedule', field: 'planned_times' },
  estimated_load_start: { tab: 'schedule', field: 'planned_times' },
  estimated_load_end: { tab: 'schedule', field: 'planned_times' },
  freight_summary_label: { tab: 'freight' },
  load_pieces: { tab: 'freight', field: 'freight_summary' },
  load_pallets: { tab: 'freight', field: 'freight_summary' },
  load_weight: { tab: 'freight', field: 'freight_summary' },
  load_weight_actual: { tab: 'freight', field: 'freight_summary' },
  load_weight_unit: { tab: 'freight', field: 'freight_summary' },
  load_length: { tab: 'freight', field: 'freight_summary' },
  load_length_unit: { tab: 'freight', field: 'freight_summary' },
  type_of_equipment: { tab: 'freight', field: 'type_of_equipment' },
  carrier_trailer: { tab: 'freight', field: 'carrier_trailer' },
  carrier_tractor: { tab: 'freight', field: 'carrier_tractor' },
  seal_number: { tab: 'freight', field: 'seal_number' },
  load_details: { tab: 'freight', field: 'load_details' },
  load_special_info: { tab: 'freight', field: 'load_special_info' },
  latest_note_preview: { tab: 'notes' },
  status_label: { tab: 'status' },
  lading_status: { tab: 'status' },
  lading_status_updated: { tab: 'status' },
  lading_status_note: { tab: 'status' },
  customer_po: { tab: 'overview', field: 'customer_po' },
  pickup_reference_number: { tab: 'overview', field: 'pickup_reference_number' },
  delivery_reference_number: { tab: 'overview', field: 'delivery_reference_number' },
  booking_number: { tab: 'overview', field: 'booking_number' },
  release_number: { tab: 'overview', field: 'release_number' },
};

export function panelTargetForColumn(columnId: string): WorkOrderPanelTarget {
  return COLUMN_TARGETS[columnId] || { tab: 'overview' };
}

export function isPanelActionTarget(target: EventTarget | null | undefined): boolean {
  return target instanceof Element && !!target.closest('button, a, input, select, textarea, [role="button"]');
}
